// api
import type {
  GetDeviceActivityDto,
  GetDeviceDto,
} from '@/api/generated/recalc/endpoints/v2/devices';

export type DeviceActivityStatus = 'online' | 'stale' | 'offline';

const HOUR_IN_MS = 60 * 60 * 1000;

function getActivityTimestamp(activity?: GetDeviceActivityDto | null) {
  if (!activity?.lastActivity) {
    return null;
  }

  const timestamp = Date.parse(activity.lastActivity);

  return Number.isFinite(timestamp) ? timestamp : null;
}

export function getLatestDeviceActivity(
  device?: GetDeviceDto | null,
): GetDeviceActivityDto | null {
  const activities = [
    device?.latestSourceActivity,
    device?.latestTargetActivity,
  ]
    .filter(Boolean)
    .map((activity) => ({
      activity,
      timestamp: getActivityTimestamp(activity),
    }))
    .filter(
      (
        activityWithTimestamp,
      ): activityWithTimestamp is {
        activity: GetDeviceActivityDto;
        timestamp: number;
      } => activityWithTimestamp.timestamp != null,
    );

  if (activities.length === 0) {
    return null;
  }

  return activities.sort((left, right) => right.timestamp - left.timestamp)[0]
    .activity;
}

export function deriveDeviceStatus(
  device?: GetDeviceDto | null,
  now = Date.now(),
): DeviceActivityStatus {
  const latestActivity = getLatestDeviceActivity(device);
  const latestActivityTimestamp = getActivityTimestamp(latestActivity);

  if (latestActivityTimestamp == null) {
    return 'offline';
  }

  return now - latestActivityTimestamp <= HOUR_IN_MS ? 'online' : 'stale';
}
